export const USERSTORYFORM_SUBMIT_ERROR = 'USERSTORYFORM_SUBMIT_ERROR';
export const USERSTORYFORM_SUBMIT_PENDING = 'USERSTORYFORM_SUBMIT_PENDING';
export const USERSTORYFORM_SUBMIT_SUCCESS = 'USERSTORYFORM_SUBMIT_SUCCESS';